import { Outlet } from 'react-router';
import Logo from '../../assets/images/RX_Logo_Black.png';
import styles from './AuthCenteredLayout.module.css';

const AuthCenteredLayout = () => (
	<div className={styles.authCenteredPage}>
		<div className={styles.authCenteredWrapper}>
			<div className={styles.authCenteredHeader}>
				<img src={Logo} alt="ReadyRx" className={styles.authCenteredLogo} />
			</div>
			<main className={styles.authCenteredColumn}>
				<Outlet />
			</main>
		</div>
		<div className={styles.authImagePanel} aria-hidden="true" />
	</div>
);

export default AuthCenteredLayout;
